/* Product-card image slider (components/activity-item-component.php, .c-card-slider): desktop grids, and the slick
   product carousels that ask for it (components/product-carousel.php image_slider → data-image-slider: the
   shore-excursion day sliders, Peter 2026-09-28). Hand-rolled — a grid page has 24+ cards, one slick per card is too
   heavy. Slide 1 is the card's own <img>; the photo slides after it hold only data-src and get their <img> the first
   time the card is hovered; the last slide is the excerpt. A card with fewer than 3 photos (data-tm-card-more-slides)
   asks on that first hover for what fills the rest (traveller photos, review snippets, the inclusions:
   tm_reviews_card_slides, robots-blocked, since review content is never in the page's source) and puts it before the
   excerpt. Ends stop (no wrap). Below 1025px nothing is initialised and the SCSS hides the whole block; a window
   widened past it gets the image_slider rows set up by product-carousel.js's resize handler (grids stay as loaded).
   Call tmProductCardSlider.init(scope) after inserting cards via AJAX. */
window.tmProductCardSlider = {
    BREAKPOINT: '(min-width: 1025px)',

    init: function (scope) {
        if (!window.matchMedia(this.BREAKPOINT).matches) {
            return;
        }
        var root = scope || document;
        var sliders = root.querySelectorAll('.c-card-slider:not(.is-ready)');
        for (var i = 0; i < sliders.length; i++) {
            // never inside a slick carousel, whatever the caller passed, unless the product carousel asked for it
            var carousel = sliders[i].closest('.slick-slider, .c-product-carousel__slider:not([data-layout="grid"])');
            if (carousel && !carousel.hasAttribute('data-image-slider')) {
                continue;
            }
            this.setup(sliders[i]);
        }
    },

    setup: function (slider) {
        var card = slider.closest('.product-card') || slider.parentElement;
        var slides = [].slice.call(slider.querySelectorAll('.c-card-slider__slide'));
        var dots = [].slice.call(slider.querySelectorAll('.c-card-slider__dots li'));
        var prev = slider.querySelector('.c-card-slider__prev');
        var next = slider.querySelector('.c-card-slider__next');
        var count = slides.length + 1;
        var index = 0;
        var loaded = false;
        var moved = false; // set on the first move off the cover; from then on the pill marks the position, slide 1 included
        // in a slick row a mouse drag moves the row, never the photo (the slider has no drag of its own)
        var row = slider.closest('.c-product-carousel__slider:not([data-layout="grid"])');
        var downX = null;

        slider.classList.add('is-ready');

        function makeImages() {
            slides.forEach(function (slide) {
                var src = slide.getAttribute('data-src');
                if (!src || slide.querySelector('img')) {
                    return;
                }
                var img = document.createElement('img');
                img.loading = 'lazy';
                img.decoding = 'async';
                img.alt = slide.getAttribute('data-alt') || '';
                img.src = src;
                slide.appendChild(img);
            });
        }

        function load() {
            if (loaded) {
                return;
            }
            loaded = true;
            makeImages();
            loadMore();
        }

        // the slides that fill the rest (data-tm-card-more-slides): before the excerpt, the dots made again for the new
        // count; the visitor stays on the slide they are on (the excerpt stays the last)
        function loadMore() {
            var query = null;
            try {
                query = JSON.parse(slider.getAttribute('data-tm-card-more-slides') || 'null');
            } catch (e) {}
            slider.removeAttribute('data-tm-card-more-slides');
            if (!query || typeof tmUtils === 'undefined') {
                return;
            }
            jQuery.ajax({ url: tmUtils.reviewsUrl('tm_reviews_card_slides', query), type: 'GET', dataType: 'json' }).done(function (response) {
                var excerpt = slider.querySelector('.c-card-slider__slide--excerpt');
                if (!response || !response.html || !excerpt) {
                    return;
                }
                var onLast = index === count - 1;
                excerpt.insertAdjacentHTML('beforebegin', response.html);
                slides = [].slice.call(slider.querySelectorAll('.c-card-slider__slide'));
                count = slides.length + 1;
                var dotList = slider.querySelector('.c-card-slider__dots');
                if (dotList) {
                    var html = '';
                    for (var i = 1; i <= count; i++) {
                        html += '<li><button type="button">' + i + '</button></li>';
                    }
                    dotList.innerHTML = html;
                    dots = [].slice.call(dotList.querySelectorAll('li'));
                    dots.forEach(bindDot);
                }
                makeImages();
                go(onLast ? count - 1 : index);
            });
        }

        function go(to) {
            index = Math.max(0, Math.min(count - 1, to));
            if (index > 0) {
                load();
            }
            slides.forEach(function (slide, i) {
                slide.classList.toggle('is-active', i + 1 === index);
            });
            // the current dot is white from page load; it becomes the pill only once the visitor has moved off the
            // cover, and stays the pill for good from then on
            moved = moved || index > 0;
            dots.forEach(function (dot, i) {
                dot.classList.toggle('is-current', i === index);
                // in a slick row the pill is is-pill: slick gives tabindex 0 to the buttons under every .slick-active of
                // its track after each move, so a slick-active dot in a card out of view would take a Tab stop
                dot.classList.toggle(row ? 'is-pill' : 'slick-active', moved && i === index);
            });
            prev.hidden = index === 0;
            next.hidden = index === count - 1;
        }

        function stop(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        // a click that ends a drag of the row (slick's own 10px): slick stops it only at .slick-list, after these
        // handlers, so they skip it themselves. Keyboard clicks (detail 0) always count
        function dragged(e) {
            return row !== null && downX !== null && e.detail > 0 && Math.abs(e.clientX - downX) > 10;
        }

        function bindDot(dot, i) {
            dot.addEventListener('click', function (e) { stop(e); if (!dragged(e)) { go(i); } });
        }

        prev.addEventListener('click', function (e) { stop(e); if (!dragged(e)) { go(index - 1); } });
        next.addEventListener('click', function (e) { stop(e); if (!dragged(e)) { go(index + 1); } });
        dots.forEach(bindDot);
        // the excerpt's "More" link is a real link; only keep the card's own click handler out of it. In a slick row
        // it bubbles: product-carousel.js's card handler skips links already, slick stops it after a drag, and on the
        // shore-excursion route another site's link first shows the leaving-our-site popup (shore-excursions/script.php)
        slider.querySelectorAll('.c-card-slider__slide a').forEach(function (link) {
            link.addEventListener('click', function (e) {
                if (row === null) {
                    e.stopPropagation();
                }
            });
        });
        if (row !== null) {
            slider.addEventListener('mousedown', function (e) { downX = e.clientX; });
            // slick made the row's images undraggable at its init; the photos added on hover are not, and a native
            // image drag would take the mouse from slick's row drag
            slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
        }

        // hover = the visitor may flick through: fetch the photos (and the slides that fill the rest) now so the first
        // click is instant
        card.addEventListener('mouseenter', load, { once: true });
        prev.hidden = true;
    }
};

jQuery(function () {
    window.tmProductCardSlider.init(document);
});
jQuery(document).on('tmActivitiesSubsetListRefreshed', function () {
    window.tmProductCardSlider.init(document);
});
